module.exports = __webpack_public_path__ + "static/media/pokeball.142cf534.webp";